import './support.scss';
import operatorImageDesktop from '../../assets/operator-desktop.svg';
import operatorImageTablet from '../../assets/operator-tablet.svg';
import operatorImagePhone from '../../assets/operator-phone.svg';
import wellstarLogo from '../../assets/wellstar.svg';
import SupportProperties from '../../types/supportProperties';
import { desktop, tablet } from '../../consts';

const Support: React.FC<SupportProperties> = props => {
    const { screen } = props;

    return (
        <div className="support">
            <div className="support-image">
                <div className="support-image-help">
                    <div className="support-image-help-headset">
                        <img
                            src={screen === desktop ? operatorImageDesktop : screen === tablet ? operatorImageTablet : operatorImagePhone}
                            alt="Help"
                            className="support-image-help-headset-vector"
                        />
                    </div>
                </div>
            </div>
            <div className="support-title">
                <h1 className="support-title-questions">Questions? Email us:</h1>
                <a href="mailto:haiku@wellstar.org" className="support-title-email">
                    haiku@wellstar.org
                </a>
            </div>
            <div className="support-socials">
                <img src={wellstarLogo} alt="Wellstar" className="support-socials-logo-inline-image" />
            </div>
        </div>
    );
};

export default Support;
